import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { DayFilterTypes } from 'app/modules/common/enums/day-filter-enums';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';
import { Validators } from '@angular/forms';

@Component({
    selector: 'app-leave-filter',
    templateUrl: './leave-filter.component.html',
    styleUrls: ['./leave-filter.component.scss'],
    standalone: false
})
export class LeaveFilterComponent implements OnInit {
  @ViewChild('medicoSelect')doctorSearchInput :ElementRef
  _medicoList :any=[];
  PoblacionList:any=[];

  DateFilterType = DateFilterTypes;
  DaysFilterType = DayFilterTypes;
  defaultDoctorValue = 0;
  filteredProvinceList: any[] = [];
  filteredPoblacionList: any[] = [];

  public provinceList: Array<{ value: string; viewValue: string }>;
  
  DoctorList$: any[];
  DayList$ = [
    { text: 'Lunes', value: 1 },
    { text: 'Martes', value: 2 },
    { text: 'Miércoles', value: 3 },
    { text: 'Jueves', value: 4 },
    { text: 'Viernes', value: 5 },
    { text: 'Sábado', value: 6 },
    { text: 'Domingo', value: 7 }
  ];
  NoDiagnosisReasons$ = [
    { text: 'Aviso baja posterior al alta', value: '1' },
    { text: 'Orden no visitar', value: '2' },
    { text: 'Aviso de baja en últimos 5 días del periodo', value: '3' },
    { text: 'Bajas de menos de 4 días de duración', value: '4' },
    { text: 'Alta inferior a 4 días del aviso de baja', value: '5' },
    { text: 'Bajas sin teléfono', value: '6' },
    { text: 'Bajas de 4 a 8 días de aviso sin gestiones', value: '7' },
    { text: 'Bajas de más de 8 días de aviso sin gestiones', value: '8' },
    { text: 'Teléfonos incorrectos', value: '9' },
    { text: 'Bajas no localizadas', value: '10' },
    { text: 'Bajas con actuación efectiva sin diagnóstico', value: '11' },
  ];
  PsychosocialRisks$ = [
    { text: 'Entorno Laboral', value: '1' },
    { text: 'Entorno Extralaboral', value: '2' }
  ];

  constructor(public selectionService: SelectionGenericService, public filterService: FilterService) { }

  ngOnInit(): void {
    this.initializeForm();
    this.getHardCodedList();
    this.selectionService.GetDoctorList().subscribe(res => {
      if (res.code === 0) {
        this.DoctorList$ = res.result;
        this._medicoList=res.result;
        this.DoctorList$.unshift({
          value: 0,
          viewValue: 'Todos',
          stringValue: null
        });
      }
    }, error => {
      console.error(error);
    });

    this.selectionService.GetCoordinatorList().subscribe(res => {
      if (res.code === 0) {
        this.filterService.CoordinadorList$ = res.result;
      }
    }, error => {
      console.error(error);
    });

    this.selectionService.GestorList().subscribe(
      (res) => {
        if (res.code === 0) {
          this.filterService.GestorList$ = res.result;
        }
      },
      (error) => {
        console.error(error);
      }
    );
    if (this.filterService.PoblacionList == undefined){
        this.selectionService.PoblacionList().subscribe(
          (res) => {
            if (res.code === 0) {
              this.filterService.PoblacionList = res.result;
              this.filteredPoblacionList = [...this.filterService.PoblacionList];
            }
          },
          (error) => {
            console.error(error);
          }
        );
    }else{
      this.filteredPoblacionList = [...this.filterService.PoblacionList];
    }
  }

  SearchDoctors()
  {
    const searchInput=this.doctorSearchInput.nativeElement.value ?
      this.doctorSearchInput.nativeElement.value.toLowerCase():'';

    this._medicoList =this.DoctorList$.filter(m=>{
      if(m.viewValue!=null)
      {
        const viewValue : string=m.viewValue.toLowerCase();
        return viewValue.indexOf(searchInput) > -1;
      }
    })
    
  }

    filtrarProvincias(event: Event): void {
    const busqueda = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredProvinceList = this.provinceList.filter(prov => 
      prov.viewValue.toLowerCase().includes(busqueda)
    );
  }

  filtrarPoblaciones(event: Event): void {
    const busqueda = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredPoblacionList = this.filterService.PoblacionList.filter((pob: string) => 
      pob.toLowerCase().includes(busqueda) 
    );
  }

  initializeForm(): void {
    this.defaultDoctorValue = !this.selectionService.leaveSelectionModal.MedicoId ? 0 : this.selectionService.leaveSelectionModal.MedicoId;
    const weekDay = !this.selectionService.leaveSelectionModal.Weekday ? null : this.selectionService.leaveSelectionModal.Weekday;
    const weekDayCount = !this.selectionService.leaveSelectionModal.WeekdayCount ? null : this.selectionService.leaveSelectionModal.WeekdayCount;
    const noDiagnosis = this.selectionService.leaveSelectionModal.IsNoDiagnosis;
    const noDiagnosisReason = !this.selectionService.leaveSelectionModal.NoDiagnosisReason ? [] : this.selectionService.leaveSelectionModal.NoDiagnosisReason.split(',');
    const psychosocialRisk = !this.selectionService.leaveSelectionModal.PsychosocialRisks ? [] : this.selectionService.leaveSelectionModal.PsychosocialRisks.split(',');

    const empresaCoordinador = this.selectionService.leaveSelectionModal.Coordinador;
    const gestor = this.selectionService.leaveSelectionModal.Gestor;

    this.filterService.LeaveSelectionMoreFilterForm.patchValue({
      Doctor: this.defaultDoctorValue,
      Weekday: weekDay,
      WeekdayCount: weekDayCount,
      NoDiagnosis: noDiagnosis,
      NoDiagnosisReason: noDiagnosisReason,
      PsychosocialRisk: psychosocialRisk,
      Coordinador: empresaCoordinador,
      Gestor: gestor
    });

    const types = !this.selectionService.leaveSelectionModal.LeaveType ? null : this.selectionService.leaveSelectionModal.LeaveType.split(',');
    this.filterService.LeaveType.setValue(types);
  }

  public SetFilterValues(filterType): void {
    this._medicoList=this.DoctorList$;
    setTimeout(() => {
      this.doctorSearchInput.nativeElement.value=null;
    }, 1000);

    switch (filterType) {
      case 'EmpresaCoordinador':
        this.selectionService.leaveSelectionModal.Coordinador = this.filterService.LeaveSelectionMoreFilterForm.value.Coordinador;
        break;
      case 'Gestor':
        this.selectionService.leaveSelectionModal.Gestor = this.filterService.LeaveSelectionMoreFilterForm.value.Gestor;
        break;

      case 'medico':
        const doctorValue = this.filterService.LeaveSelectionMoreFilterForm.value.Doctor === 0 ?
          undefined : this.filterService.LeaveSelectionMoreFilterForm.value.Doctor;
        this.selectionService.leaveSelectionModal.MedicoId = doctorValue;
        break;

      case 'leavesWeekday':
        this.selectionService.leaveSelectionModal.Weekday = this.filterService.LeaveSelectionMoreFilterForm.value.Weekday;
        break;

      case 'leavesWeekdayCount':
        let count = 0;
        if (this.filterService.LeaveSelectionMoreFilterForm.get('WeekdayCount').valid) {
          count = Number(this.filterService.LeaveSelectionMoreFilterForm.value.WeekdayCount);
        }

        this.selectionService.leaveSelectionModal.WeekdayCount = count;
        break;

      case 'noDiagnosis':
        // if(this.filterService.LeaveSelectionMoreFilterForm.value.NoDiagnosis)
        // {
        //   this.filterService.LeaveSelectionMoreFilterForm.get("NoDiagnosisReason").setValidators([Validators.required]);
        //   this.filterService.LeaveSelectionMoreFilterForm.markAllAsTouched();
        // }else {
        //   this.filterService.LeaveSelectionMoreFilterForm.get("NoDiagnosisReason").setValidators([]);
        //   this.filterService.LeaveSelectionMoreFilterForm.get("NoDiagnosisReason").setErrors(null);
        //   this.filterService.LeaveSelectionMoreFilterForm.updateValueAndValidity();
        // }
        this.selectionService.leaveSelectionModal.IsNoDiagnosis = this.filterService.LeaveSelectionMoreFilterForm.value.NoDiagnosis;
        break;

      case 'noDiagnosisReason':
        const reasonsArray = this.filterService.LeaveSelectionMoreFilterForm.value.NoDiagnosisReason;
        let reasons = '';
        reasonsArray.forEach(reason => {
          reasons += reason + ',';
        });

        this.selectionService.leaveSelectionModal.NoDiagnosisReason = reasons.replace(/,\s*$/, '');
        break;

      case 'psychosocialRisk':
        const risksArray = this.filterService.LeaveSelectionMoreFilterForm.value.PsychosocialRisk;
        let risks = '';
        risksArray.forEach(risk => {
          risks += risk + ',';
        });

        this.selectionService.leaveSelectionModal.PsychosocialRisks = risks.replace(/,\s*$/, '');
        break;

      default:
        break;
    }
  }

  public SetDatePeriodValues(dateType: DateFilterTypes, inputType: string, value: Date): void {
    const dateValue = DateHelper.getUTCDateString(value);
    switch (dateType) {
      case DateFilterTypes.Communication:
        if (inputType === 'F') {
          this.selectionService.leaveSelectionModal.CommunicationDateFrom = dateValue;
        }
        else {
          this.selectionService.leaveSelectionModal.CommunicationDateTo = dateValue;
        }
        break;

      case DateFilterTypes.Discharge:
        if (inputType === 'F') {
          this.selectionService.leaveSelectionModal.DischargeDateFrom = dateValue;
        }
        else {
          this.selectionService.leaveSelectionModal.DischargeDateTo = dateValue;
        }
        break;

      case DateFilterTypes.NewLeave:
        if (inputType === 'F') {
          this.selectionService.leaveSelectionModal.NewLeaveDateFrom = dateValue;
        }
        else {
          this.selectionService.leaveSelectionModal.NewLeaveDateTo = dateValue;
        }
        break;

      default:
        break;
    }
  }

  public SetDayValues(dateType: DayFilterTypes, inputType: string, value: number): void {
    switch (dateType) {
      case DayFilterTypes.Leave:
        if (inputType === 'F') {
          this.selectionService.leaveSelectionModal.LeaveDaysFrom = value;
        }
        else {
          this.selectionService.leaveSelectionModal.LeaveDaysTo = value;
        }
        break;

      case DayFilterTypes.LeaveEndOfPeriod:
        if (inputType === 'F') {
          this.selectionService.leaveSelectionModal.LeaveEndOfPeriodDaysFrom = value;
        }
        else {
          this.selectionService.leaveSelectionModal.LeaveEndOfPeriodDaysTo = value;
        }
        break;

      case DayFilterTypes.LeaveInPeriod:
        if (inputType === 'F') {
          this.selectionService.leaveSelectionModal.LeaveInPeriodDaysFrom = value;
        }
        else {
          this.selectionService.leaveSelectionModal.LeaveInPeriodDaysTo = value;
        }
        break;

      case DayFilterTypes.Labor:
        if (inputType === 'F') {
          this.selectionService.leaveSelectionModal.LaborDaysFrom = value;
        }
        else {
          this.selectionService.leaveSelectionModal.LaborDaysTo = value;
        }
        break;

      case DayFilterTypes.LaborEndOfPeriod:
        if (inputType === 'F') {
          this.selectionService.leaveSelectionModal.LaborEndOfPeriodDaysFrom = value;
        }
        else {
          this.selectionService.leaveSelectionModal.LaborEndOfPeriodDaysTo = value;
        }
        break;

      case DayFilterTypes.LaborInPeriod:
        if (inputType === 'F') {
          this.selectionService.leaveSelectionModal.LaborInPeriodDaysFrom = value;
        }
        else {
          this.selectionService.leaveSelectionModal.LaborInPeriodDaysTo = value;
        }
        break;

      case DayFilterTypes.LeaveCommunicationGap:
        if (inputType === 'F') {
          this.selectionService.leaveSelectionModal.LeaveCommunicationGapDaysFrom = value;
        }
        else {
          this.selectionService.leaveSelectionModal.LeaveCommunicationGapDaysTo = value;
        }
        break;

      default:
        break;
    }
  }

  SetLeaveType(leaveTypeArray: any[]): void {
    let leaveTypes = '';
    if (leaveTypeArray !== null) {
      leaveTypeArray.forEach(leaveType => {
        leaveTypes += leaveType + ',';
      });
    }

    this.selectionService.leaveSelectionModal.LeaveType = leaveTypes.replace(/,\s*$/, '');
  }

  SetAttribute(attributeList: any[]): void {
    this.selectionService.leaveSelectionModal.AttributeList = attributeList;
  }

  SetAttributeModal(attributeModal: any[]): void {
    this.filterService.selectedAttribute = attributeModal;
  }

  onProvinciaChange(valorProvincia: string): void {
    if (valorProvincia) {
      this.selectionService.leaveSelectionModal.Poblacion = '';
    }
    this.selectionService.leaveSelectionModal.Provincia = valorProvincia;
  }

  onPoblacionChange(valorPoblacion: any): void {
    if (valorPoblacion) {
      this.selectionService.leaveSelectionModal.Provincia = '';
    }
    this.selectionService.leaveSelectionModal.Poblacion = valorPoblacion;
  }


  getHardCodedList(): void {
        this.provinceList = [
            { value: 'ALAVA', viewValue: 'ALAVA' },
            { value: 'ALBACETE', viewValue: 'ALBACETE' },
            { value: 'ALICANTE', viewValue: 'ALICANTE' },
            { value: 'ALMERIA', viewValue: 'ALMERIA' },
            { value: 'ANDORRA', viewValue: 'ANDORRA' },
            { value: 'ASTURIAS', viewValue: 'ASTURIAS' },
            { value: 'AVILA', viewValue: 'AVILA' },
            { value: 'BADAJOZ', viewValue: 'BADAJOZ' },
            { value: 'BALEARES', viewValue: 'BALEARES' },
            { value: 'BARCELONA', viewValue: 'BARCELONA' },
            { value: 'BURGOS', viewValue: 'BURGOS' },
            { value: 'CACERES', viewValue: 'CACERES' },
            { value: 'CADIZ', viewValue: 'CADIZ' },
            { value: 'CANTABRIA', viewValue: 'CANTABRIA' },
            { value: 'CASTELLON', viewValue: 'CASTELLON' },
            { value: 'CEUTA', viewValue: 'CEUTA' },
            { value: 'CIUDAD REAL', viewValue: 'CIUDAD REAL' },
            { value: 'CORDOBA', viewValue: 'CORDOBA' },
            { value: 'CUENCA', viewValue: 'CUENCA' },
            { value: 'GIRONA', viewValue: 'GIRONA' },
            { value: 'GRANADA', viewValue: 'GRANADA' },
            { value: 'GUADALAJARA', viewValue: 'GUADALAJARA' },
            { value: 'GUIPUZCOA', viewValue: 'GUIPUZCOA' },
            { value: 'HUELVA', viewValue: 'HUELVA' },
            { value: 'HUESCA', viewValue: 'HUESCA' },
            { value: 'JAEN', viewValue: 'JAEN' },
            { value: 'LA CORUÑA', viewValue: 'LA CORUÑA' },
            { value: 'LAS RIOJA', viewValue: 'LAS RIOJA' },
            { value: 'LAS PALMAS', viewValue: 'LAS PALMAS' },
            { value: 'LEON', viewValue: 'LEON' },
            { value: 'LLEIDA', viewValue: 'LLEIDA' },
            { value: 'LUGO', viewValue: 'LUGO' },
            { value: 'MADRID', viewValue: 'MADRID' },
            { value: 'MALAGA', viewValue: 'MALAGA' },
            { value: 'MELILLA', viewValue: 'MELILLA' },
            { value: 'MURCIA', viewValue: 'MURCIA' },
            { value: 'NAVARRA', viewValue: 'NAVARRA' },
            { value: 'ORENSE', viewValue: 'ORENSE' },
            { value: 'PALENCIA', viewValue: 'PALENCIA' },
            { value: 'PONTEVEDRA', viewValue: 'PONTEVEDRA' },
            { value: 'SALAMANCA', viewValue: 'SALAMANCA' },
            {
                value: 'SANTA CRUZ DE TENERIFE',
                viewValue: 'SANTA CRUZ DE TENERIFE',
            },
            { value: 'SEGOVIA', viewValue: 'SEGOVIA' },
            { value: 'SEVILLA', viewValue: 'SEVILLA' },
            { value: 'SORIA', viewValue: 'SORIA' },
            { value: 'TARRAGONA', viewValue: 'TARRAGONA' },
            { value: 'TERUEL', viewValue: 'TERUEL' },
            { value: 'TOLEDO', viewValue: 'TOLEDO' },
            { value: 'VALENCIA', viewValue: 'VALENCIA' },
            { value: 'VALLADOLID', viewValue: 'VALLADOLID' },
            { value: 'VIZCAYA', viewValue: 'VIZCAYA' },
            { value: 'ZAMORA', viewValue: 'ZAMORA' },
            { value: 'ZARAGOZA', viewValue: 'ZARAGOZA' },
        ];

        this.filteredProvinceList = [...this.provinceList];
    }

}
